import React from 'react'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { Modal, ModalDragHandle } from '@ztechapps/webui.modal'
import { ShowIf } from '@ztechapps/webui.util'
import { useBuildButtonContext } from './Context'
import { useBillOfMaterialsContext } from '../Context'
import type { CreateAndBuildProps } from '@ztechapps/webui.contract'
import { WebuiIocKey, useInjectComponent } from '@ztechapps/webui.contract'

export const Layout = () => {
  const { product, qtyNeededToBuild } = useBuildButtonContext()
  const { canEdit } = useBillOfMaterialsContext()
  const CreateAndBuild = useInjectComponent<CreateAndBuildProps>(WebuiIocKey.workOrder.createAndBuild)

  return (
    <ShowIf condition={product?.hasSubComponents}>
      <Modal
        centered
        size="lg"
        trigger={({ onClick }) => (
          <BusyButtonLink
            disabled={!canEdit}
            icon="hammer"
            title="Do a production build for this product."
            onClick={onClick}
          />
        )}
      >
        {({ toggleShowModal }) => (
          <>
            <ModalDragHandle>Quick build for a product</ModalDragHandle>
            <CreateAndBuild
              productId={product?._id}
              canEdit={canEdit}
              qtyToBuild={qtyNeededToBuild}
              afterCreateAndBuild={toggleShowModal}
              remarks={'Build from product BOM'}
            />
          </>
        )}
      </Modal>
    </ShowIf>
  )
}
